import { c as _c } from "react/compiler-runtime";
import { clsx } from 'clsx';
import { OverlayArrow, Tooltip as RAC_Tooltip } from 'react-aria-components';
import styles from './Tooltip.module.css';
import type { TooltipProps } from './Tooltip.types';
function Tooltip(t0) {
  const $ = _c(16);
  let children;
  let className;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      children,
      hasArrow: t1,
      variant: t2,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
    $[4] = t1;
    $[5] = t2;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
    t1 = $[4];
    t2 = $[5];
  }
  const hasArrow = t1 === undefined ? true : t1;
  const variant = t2 === undefined ? "contrast" : t2;
  const t3 = styles[variant];
  let t4;
  if ($[6] !== className || $[7] !== t3) {
    t4 = clsx(styles.tooltip, t3, className);
    $[6] = className;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== hasArrow) {
    t5 = hasArrow && <OverlayArrow className={styles.overlayArrow}><svg width={12} height={12} viewBox="0 0 8 8" aria-hidden="true"><path d="M0 0 L4 4 L8 0" /></svg></OverlayArrow>;
    $[9] = hasArrow;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== children || $[12] !== props || $[13] !== t4 || $[14] !== t5) {
    t6 = <RAC_Tooltip data-test-id="Tooltip" className={t4} {...props}>{t5}{children}</RAC_Tooltip>;
    $[11] = children;
    $[12] = props;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}
export { Tooltip };